import React from 'react';
import ToastBase from './ToastBase';

import TToast from './@types/TToast';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

/**
 * @deprecated you should use ErrorToast instead
 */
const Warning = ({ children, icon, ...rest }: TToast) => {
  return (
    <ToastBase signal={FeedbackSignals.Error} icon={icon} {...rest}>
      {children}
    </ToastBase>
  );
};

export default Warning;
